import * as Sentry from '@sentry/react';
import { Config, ENV } from '@/config/environment';
import replayPrivacyOptions from '@/helpers/sentryReplayOptions';

// Custom Web Vitals integration for Sentry
const webVitalsIntegration = () => {
  return {
    name: 'WebVitals',
    setup() {
      // Web vitals are reported through the webVitals service
      // This integration ensures they're properly formatted for Sentry
    },
  };
};

export const initSentry = () => {
  if (Config.features.enableSentry && Config.features.sentryDsn) {
    Sentry.init({
      dsn: Config.features.sentryDsn,
      environment: ENV.current,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(replayPrivacyOptions),
        webVitalsIntegration(),
      ],
      tracesSampleRate: ENV.isProd ? 0.1 : 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      // Add custom tags for web vitals
      initialScope: {
        tags: {
          'web_vitals.enabled': 'true',
        },
      },
      beforeSend(event, hint) {
        // Filter out certain errors if needed
        if (event.exception) {
          const error = hint.originalException;
          
          // Don't send network errors in development
          if (!ENV.isProd && error instanceof Error && error.message.includes('Network')) {
            return null;
          }
        }
        
        // Add web vitals context if available
        if (event.tags?.['web_vitals.metric']) {
          event.contexts = {
            ...event.contexts,
            web_vitals: {
              metric: event.tags['web_vitals.metric'],
              rating: event.tags['web_vitals.rating'],
            },
          };
        }
        
        return event;
      },
    });

    // Set user context if available
    const userInfo = localStorage.getItem('user_info');
    if (userInfo) {
      try {
        const user = JSON.parse(userInfo);
        Sentry.setUser({
          id: user.sub,
          email: user.email,
          username: user.preferred_username,
        });
      } catch {
        // Ignore parse errors
      }
    }
  }
};

export { replayPrivacyOptions };
